import React from 'react';

class NotFoundScreen extends React.Component {
  render() {
    return <div>Page Not Found</div>;
  }
}

export default NotFoundScreen;
